// P3 pictures (v0.6.0 Part 6): read at print time — the issue's own snapshots (max 6) and the newest log-entry
// snapshot — with a URL for each (Supabase: signed, 1 hour). Pictures are not stored with the version (like the
// cover photo), so printing an older version again shows today's pictures.
import { files, rpc } from "../../../core/api/backend";
import type { PdfSnaps } from "./PrintPages";
import type { PrintContext } from "../../../core/api/types";

/** v0.7.0: cover photo / logos may be stored files (object names) — swap them for URLs before printing. Data URLs stay. */
export async function resolveCoverPictures(ctx: PrintContext): Promise<PrintContext> {
  const out = { ...ctx };
  for (const k of ["photo", "client_logo", "prepared_logo", "owner_logo"] as const) {
    const v = out[k];
    if (v && !v.startsWith("data:")) out[k] = await files.url(v).catch(() => null);
  }
  return out;
}

export async function loadPrintSnaps(code: string, prefix: string): Promise<PdfSnaps> {
  const raw = await rpc("issues_print_snapshots", { code, prefix });
  const out: PdfSnaps = {};
  await Promise.all(Object.entries(raw).map(async ([issue, s]) => {
    out[issue] = {
      pictures: await Promise.all(s.pictures.map((p) => files.url(p))),
      total: s.total,
      log: s.log ? { entry_date: s.log.entry_date, note: s.log.note, url: await files.url(s.log.path) } : null,
    };
  }));
  return out;
}
